// Country bounding boxes: [southwest_lng, southwest_lat, northeast_lng, northeast_lat]
// Source: Natural Earth / common geographic references
const countryBounds = {
  af: [60.5, 29.4, 74.9, 38.5],
  al: [19.3, 39.6, 21.1, 42.7],
  dz: [-8.7, 19.1, 12.0, 37.1],
  ad: [1.4, 42.4, 1.8, 42.7],
  ao: [11.7, -18.0, 24.1, -4.4],
  ag: [-62.0, 16.9, -61.7, 17.7],
  ar: [-73.6, -55.1, -53.6, -21.8],
  am: [43.4, 38.8, 46.6, 41.3],
  au: [113.2, -43.6, 153.6, -10.7],
  at: [9.5, 46.4, 17.2, 49.0],
  az: [44.8, 38.4, 50.4, 41.9],
  bs: [-79.0, 21.0, -73.0, 27.3],
  bh: [50.4, 25.8, 50.7, 26.3],
  bd: [88.0, 20.7, 92.7, 26.6],
  bb: [-59.7, 13.0, -59.4, 13.3],
  by: [23.2, 51.3, 32.8, 56.2],
  be: [2.5, 49.5, 6.4, 51.5],
  bz: [-89.2, 15.9, -87.5, 18.5],
  bj: [0.8, 6.2, 3.8, 12.4],
  bt: [88.7, 26.7, 92.1, 28.3],
  bo: [-69.6, -22.9, -57.5, -9.7],
  ba: [15.7, 42.6, 19.6, 45.3],
  bw: [20.0, -27.0, 29.4, -17.8],
  br: [-73.9, -33.7, -34.8, 5.3],
  bn: [114.1, 4.0, 115.4, 5.0],
  bg: [22.4, 41.2, 28.6, 44.2],
  bf: [-5.5, 9.4, 2.4, 15.1],
  bi: [29.0, -4.5, 30.8, -2.3],
  kh: [102.3, 10.4, 107.6, 14.7],
  cm: [8.5, 1.7, 16.2, 13.1],
  ca: [-141.0, 41.7, -52.6, 83.1],
  cv: [-25.4, 14.8, -22.7, 17.2],
  cf: [14.4, 2.2, 27.5, 11.0],
  td: [13.5, 7.4, 24.0, 23.5],
  cl: [-75.6, -55.6, -66.9, -17.5],
  cn: [73.5, 18.2, 134.8, 53.6],
  co: [-79.0, -4.2, -66.9, 12.5],
  km: [43.2, -12.4, 44.5, -11.4],
  cg: [11.2, -5.0, 18.6, 3.7],
  cd: [12.2, -13.5, 31.3, 5.4],
  cr: [-86.0, 8.0, -82.6, 11.2],
  ci: [-8.6, 4.4, -2.5, 10.7],
  hr: [13.5, 42.4, 19.4, 46.6],
  cu: [-85.0, 19.8, -74.1, 23.2],
  cy: [32.3, 34.6, 34.6, 35.7],
  cz: [12.1, 48.6, 18.9, 51.1],
  dk: [8.1, 54.6, 15.2, 57.8],
  dj: [41.8, 10.9, 43.5, 12.7],
  dm: [-61.5, 15.2, -61.2, 15.6],
  do: [-72.0, 17.5, -68.3, 19.9],
  ec: [-81.1, -5.0, -75.2, 1.4],
  eg: [25.0, 22.0, 35.8, 31.7],
  sv: [-90.1, 13.2, -87.7, 14.4],
  gq: [5.6, -1.5, 11.3, 3.8],
  er: [36.4, 12.4, 43.1, 18.0],
  ee: [21.8, 57.5, 28.2, 59.7],
  sz: [30.8, -27.3, 32.1, -25.7],
  et: [33.0, 3.4, 48.0, 14.9],
  fj: [177.0, -21.0, -179.0, -12.5],
  fi: [20.6, 59.8, 31.6, 70.1],
  fr: [-5.1, 42.3, 8.2, 51.1],
  ga: [8.7, -4.0, 14.5, 2.3],
  gm: [-16.8, 13.1, -13.8, 13.8],
  ge: [40.0, 41.1, 46.7, 43.6],
  de: [5.9, 47.3, 15.0, 55.1],
  gh: [-3.3, 4.7, 1.2, 11.2],
  gr: [19.4, 34.8, 29.7, 41.7],
  gd: [-61.8, 12.0, -61.6, 12.2],
  gt: [-92.2, 13.7, -88.2, 17.8],
  gn: [-15.1, 7.2, -7.6, 12.7],
  gw: [-16.7, 10.9, -13.6, 12.7],
  gy: [-61.4, 1.2, -56.5, 8.6],
  ht: [-74.5, 18.0, -71.6, 20.1],
  hn: [-89.4, 13.0, -83.2, 16.5],
  hu: [16.1, 45.7, 22.9, 48.6],
  is: [-24.3, 63.4, -13.5, 66.5],
  in: [68.2, 7.0, 97.4, 35.5],
  id: [95.0, -11.0, 141.0, 6.1],
  ir: [44.0, 25.1, 63.3, 39.8],
  iq: [38.8, 29.1, 48.6, 37.4],
  ie: [-10.5, 51.4, -6.0, 55.4],
  il: [34.3, 29.5, 35.9, 33.3],
  it: [6.6, 36.6, 18.5, 47.1],
  jm: [-78.4, 17.7, -76.2, 18.5],
  jp: [129.4, 31.0, 145.5, 45.5],
  jo: [34.9, 29.2, 39.2, 33.4],
  kz: [46.5, 40.6, 87.4, 55.4],
  ke: [33.9, -4.7, 41.9, 5.0],
  ki: [172.0, -3.0, -150.0, 3.0],
  kw: [46.6, 28.5, 48.4, 30.1],
  kg: [69.3, 39.2, 80.3, 43.3],
  la: [100.1, 13.9, 107.7, 22.5],
  lv: [21.0, 55.7, 28.2, 58.1],
  lb: [35.1, 33.1, 36.6, 34.7],
  ls: [27.0, -30.7, 29.5, -28.6],
  lr: [-11.5, 4.4, -7.4, 8.5],
  ly: [9.3, 19.6, 25.2, 33.2],
  li: [9.5, 47.0, 9.6, 47.3],
  lt: [21.0, 53.9, 26.8, 56.4],
  lu: [5.7, 49.4, 6.5, 50.2],
  mg: [43.2, -25.6, 50.5, -11.9],
  mw: [32.7, -17.1, 35.9, -9.4],
  my: [100.0, 0.9, 119.3, 7.4],
  mv: [72.6, -0.7, 73.8, 7.1],
  ml: [-12.2, 10.2, 4.3, 25.0],
  mt: [14.2, 35.8, 14.6, 36.1],
  mh: [165.0, 4.6, 172.0, 14.6],
  mr: [-17.1, 14.7, -4.8, 27.3],
  mu: [57.3, -20.5, 57.8, -20.0],
  mx: [-117.1, 14.5, -86.7, 32.7],
  fm: [138.0, 1.0, 163.0, 10.0],
  md: [26.6, 45.5, 30.2, 48.5],
  mc: [7.4, 43.7, 7.4, 43.8],
  mn: [87.8, 41.6, 119.9, 52.2],
  me: [18.5, 41.9, 20.4, 43.6],
  ma: [-13.2, 27.7, -1.0, 35.9],
  mz: [30.2, -26.9, 40.8, -10.5],
  mm: [92.2, 9.8, 101.2, 28.5],
  na: [11.7, -29.0, 25.3, -16.9],
  nr: [166.9, -0.6, 167.0, -0.5],
  np: [80.1, 26.4, 88.2, 30.4],
  nl: [3.4, 50.8, 7.2, 53.5],
  nz: [166.5, -47.3, 178.5, -34.4],
  ni: [-87.7, 10.7, -83.1, 15.0],
  ne: [0.2, 11.7, 16.0, 23.5],
  ng: [2.7, 4.3, 14.7, 13.9],
  kp: [124.3, 37.7, 130.7, 43.0],
  mk: [20.5, 40.9, 23.0, 42.4],
  no: [4.7, 58.0, 31.1, 71.2],
  om: [52.0, 16.6, 59.8, 26.4],
  pk: [60.9, 23.7, 77.8, 37.1],
  pw: [134.1, 6.9, 134.7, 7.7],
  pa: [-83.1, 7.2, -77.2, 9.6],
  pg: [141.0, -10.7, 156.0, -1.4],
  py: [-62.6, -27.6, -54.3, -19.3],
  pe: [-81.3, -18.3, -68.7, -0.04],
  ph: [117.2, 5.0, 126.6, 18.5],
  pl: [14.1, 49.0, 24.1, 54.8],
  pt: [-9.5, 37.0, -6.2, 42.2],
  qa: [50.7, 24.5, 51.6, 26.2],
  ro: [20.2, 43.6, 30.0, 48.3],
  ru: [27.0, 41.2, 180.0, 81.9],
  rw: [28.9, -2.8, 30.9, -1.1],
  kn: [-62.9, 17.1, -62.5, 17.4],
  lc: [-61.1, 13.7, -60.9, 14.1],
  vc: [-61.5, 12.6, -61.1, 13.4],
  ws: [-172.8, -14.1, -171.4, -13.4],
  sm: [12.4, 43.9, 12.5, 44.0],
  st: [6.5, 0.0, 7.5, 1.7],
  sa: [34.6, 16.4, 55.7, 32.2],
  sn: [-17.5, 12.3, -11.4, 16.7],
  rs: [18.8, 42.2, 23.0, 46.2],
  sc: [55.4, -4.8, 55.5, -4.3],
  sl: [-13.3, 6.9, -10.3, 10.0],
  sg: [103.6, 1.2, 104.0, 1.5],
  sk: [16.8, 47.7, 22.6, 49.6],
  si: [13.4, 45.4, 16.6, 46.9],
  sb: [155.5, -10.8, 167.0, -6.6],
  so: [41.0, -1.7, 51.4, 12.0],
  za: [16.5, -34.8, 32.9, -22.1],
  kr: [126.0, 33.1, 129.6, 38.6],
  ss: [24.0, 3.5, 35.9, 12.2],
  es: [-9.3, 36.0, 3.3, 43.8],
  lk: [79.7, 5.9, 81.9, 9.8],
  sd: [21.8, 8.7, 38.6, 22.0],
  sr: [-58.1, 1.8, -54.0, 6.0],
  se: [11.1, 55.3, 24.2, 69.1],
  ch: [5.9, 45.8, 10.5, 47.8],
  sy: [35.7, 32.3, 42.4, 37.3],
  tw: [120.0, 21.9, 122.0, 25.3],
  tj: [67.4, 36.7, 75.1, 41.0],
  tz: [29.3, -11.7, 40.4, -1.0],
  th: [97.3, 5.6, 105.6, 20.5],
  tl: [124.9, -9.5, 127.3, -8.3],
  tg: [-0.1, 6.1, 1.8, 11.1],
  to: [-175.7, -21.5, -173.7, -15.6],
  tt: [-62.0, 10.0, -60.5, 10.9],
  tn: [7.5, 30.2, 11.6, 37.5],
  tr: [26.0, 36.0, 44.8, 42.1],
  tm: [52.5, 35.1, 66.7, 42.8],
  tv: [176.1, -8.6, 179.9, -5.7],
  ug: [29.6, -1.5, 35.0, 4.2],
  ua: [22.1, 44.4, 40.2, 52.4],
  ae: [51.6, 22.6, 56.4, 26.1],
  gb: [-7.6, 49.9, 1.8, 58.6],
  us: [-124.7, 24.5, -66.9, 49.4],
  uy: [-58.4, -35.0, -53.1, -30.1],
  uz: [56.0, 37.2, 73.1, 45.6],
  vu: [166.5, -20.3, 170.2, -13.1],
  ve: [-73.4, 0.7, -59.8, 12.2],
  vn: [102.1, 8.6, 109.5, 23.4],
  ye: [42.6, 12.6, 54.5, 19.0],
  zm: [22.0, -18.1, 33.5, -8.2],
  zw: [25.2, -22.4, 33.1, -15.6],
  ps: [34.2, 31.2, 35.6, 32.6],
  va: [12.44, 41.9, 12.46, 41.91],
};

export default countryBounds;
